import {DeviceOverviewComponent} from './device-overview.component';
import {DeviceFormComponent} from './device-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'management.device',
    component: DeviceOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.device.pageTitle',
      scopes: ['management:read']
    }
  },
  {
    name: 'management.device.add',
    component: DeviceFormComponent,
    future: true,
    data: {
      pageTitle: 'states.device.add.pageTitle',
      scopes: ['management:create']
    }
  },
  {
    name: 'management.device.edit',
    component: DeviceFormComponent,
    future: true,
    data: {
      pageTitle: 'states.device.edit.pageTitle',
      scopes: ['management:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class DeviceRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device.routes.ts